import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/services/base-service';
import { environment } from 'src/environments/environment';
import { ComplementaryProduct } from 'src/app/models/configurators-2d/complementary-products/complementary-product';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ComplementaryProductFavoriteService extends BaseService {
  public favoriteProducts$ = new BehaviorSubject<ComplementaryProduct[]>([]);

  public get baseApiUrl() {
    return environment.configurators2d.baseApi;
  }

  public get apiUrl() {
    return this.baseApiUrl + 'ComplementaryProductFavorite/';
  }

  constructor() {
    super();
  }

  public async addFavorite(product: ComplementaryProduct) {
    try {
      let res = await this.post(`${this.apiUrl}AddFavorite`, { complementaryProductId: product.id });
      this.applyAddFavorite(product);
      return res;
    } catch (error) {
      console.error(error);
    }
  }

  private applyAddFavorite(product: ComplementaryProduct) {
    const current = this.favoriteProducts$.getValue();
    this.favoriteProducts$.next([...current, product]);
  }

  public async removeFavorite(product: ComplementaryProduct) {
    try {
      let res = await this.post(`${this.apiUrl}RemoveFavorite`, { complementaryProductId: product.id });
      this.applyRemoveFavorite(product);
      return res;
    } catch (error) {
      console.error(error);
    }
  }

  private applyRemoveFavorite(product: ComplementaryProduct) {
    let current = this.favoriteProducts$.getValue();
    current = current.filter(p => p.ean !== product.ean);
    this.favoriteProducts$.next(current);
  }

  public async loadUserFavorites(): Promise<void> {
    const favorites = await this.get(`${this.apiUrl}GetUserFavorites`);
    this.favoriteProducts$.next(favorites);
  }

  public getFavoriteProducts$() {
    return this.favoriteProducts$.asObservable();
  }
}
